import { z } from "zod/v4";
import { LocalDateTime } from "./local-date-time";
const LocalDateTimeRangeSchema = z
    .object({
    startAt: LocalDateTime.schema,
    endAt: LocalDateTime.schema,
})
    .refine(({ startAt, endAt }) => LocalDateTime.isBeforeOrEqual(startAt, endAt), { error: "開始日時は終了日時よりも前の日付を指定して下さい。" })
    .brand("Range");
export const LocalDateTimeRange = {
    schema: LocalDateTimeRangeSchema,
};
//# sourceMappingURL=local-date-time-range.js.map